import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

import _ from 'lodash'
import { computed } from 'vue'

type Value = string | number | Record<PropertyKey, unknown> | null

interface IProps {
  modelValue: boolean | Value[]
  val?: Value
  disable?: boolean
  activeIcon?: string
  inActiveIcon?: string
  customColor?: string
}

interface IEmits {
  (event: 'update:modelValue', data: boolean | Value[]): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KToggle' },
  __name: 'KToggle',
  props: {
    modelValue: { type: [Boolean, Array] },
    val: { default: null },
    disable: { type: Boolean, default: false },
    activeIcon: { default: '' },
    inActiveIcon: { default: '' },
    customColor: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const props = __props

const emit = __emit

const isChecked = computed(() => {
  if (typeof props.modelValue === 'boolean') return props.modelValue
  return hasValueInArray()
})

const handleToggle = () => {
  if (!props.disable) {
    if (typeof props.modelValue === 'boolean') return emit('update:modelValue', !props.modelValue)

    let newModelValue = [...props.modelValue]
    // NOTE: that means Toggle was selected and want to deselect
    if (hasValueInArray()) newModelValue = newModelValue.filter((val) => !_.isEqual(val, props.val))
    else newModelValue.push(props.val)

    emit('update:modelValue', newModelValue)
    newModelValue = []
  }
}

const hasValueInArray = () => {
  if (!Array.isArray(props.modelValue)) return false
  return props.modelValue.findIndex((value) => _.isEqual(value, props.val)) !== -1
}

return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-toggle cursor-pointer", [
      !__props.customColor
        ? !__props.disable
          ? isChecked.value
            ? 'bg-space-b-100'
            : 'bg-cool-gray-40'
          : 'bg-space-b-20 cursor-not-allowed'
        : `bg-${__props.customColor}`,
    ]]),
    onClick: _withModifiers(handleToggle, ["stop"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["k-toggle__bullet rounded-circle", [
        !__props.disable ? 'bg-white' : 'bg-static-light',
        {
          'k-toggle__bullet--active': isChecked.value,
          'k-toggle__bullet--active-iconed': isChecked.value && __props.activeIcon && __props.inActiveIcon,
        },
      ]])
    }, [
      (__props.activeIcon && __props.inActiveIcon)
        ? (_openBlock(), _createBlock(_component_k_icon, {
            key: 0,
            name: isChecked.value ? __props.activeIcon : __props.inActiveIcon,
            color: !__props.customColor ? (isChecked.value ? 'space-b-100' : 'cool-gray-70') : __props.customColor,
            size: "16px"
          }, null, 8 /* PROPS */, ["name", "color"]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

})